// import BackgroundVideo from '../../../resources/scripts/helpers/background-video';
import { debounce } from 'lodash';
import smoothscroll from 'smoothscroll-polyfill';
import isIEbrowser from '../../../resources/scripts/helpers/is-IE';

class BrixCrossReference {
  static init(...parameters) {
    return new BrixCrossReference(...parameters);
  }

  constructor(selector) {
    this.selector = selector;
    this.scrollWrapper = this.selector.querySelector('.scroll-wrapper');
    this.posts = this.selector.querySelector('.posts');
    this.scrollLeftButton = this.selector.querySelector('.scroll-button.-left');
    this.scrollRightButton = this.selector.querySelector('.scroll-button.-right');
    this.images = this.selector.querySelectorAll('.image-wrapper');

    const imageWidth = this.images[0].clientWidth;

    const IE = isIEbrowser();
    if (this.posts && IE) {
      window.objectFitPolyfill();
    }

    smoothscroll.polyfill();

    this.scrollLeftButton.addEventListener('click', () => {
      const scrollDistance = window.innerWidth < 576 ? -imageWidth : -410;

      this.posts.scrollBy({
        top: 0,
        left: scrollDistance,
        behavior: 'smooth',
      });
    });

    this.scrollRightButton.addEventListener('click', () => {
      const scrollDistance = window.innerWidth < 576 ? imageWidth : 410;

      this.posts.scrollBy({
        top: 0,
        left: scrollDistance,
        behavior: 'smooth',
      });
    });

    this.toggleScrollControls();

    window.addEventListener('resize', debounce(() => { this.toggleScrollControls(); }, 50));
    this.posts.addEventListener('scroll', debounce(() => { this.toggleButtonVisibility(); }, 50));
  }

  toggleScrollControls() {
    if (this.posts && this.scrollWrapper) {
      // NOTE: 64 = negative margin on the scroll wrapper
      if (this.posts.scrollWidth > this.scrollWrapper.offsetWidth + 64) {
        this.toggleButtonVisibility();
      } else {
        this.scrollLeftButton.classList.add('-hide');
        this.scrollRightButton.classList.add('-hide');
      }
    }
  }

  toggleButtonVisibility() {
    this.scrollRightButton.classList.remove('-hide');

    // Show left scroll button
    if (this.posts.scrollLeft > 1 && this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollLeftButton.classList.remove('-hide');
    }

    // Hide left scroll button
    if (this.posts.scrollLeft < 1 && !this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollLeftButton.classList.add('-hide');
    }

    // Show right scroll button
    if (this.posts.scrollLeft > 1 && this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollRightButton.classList.remove('-hide');
    }

    // Show right scroll button
    if (this.posts.scrollLeft + this.posts.offsetWidth
      <= this.posts.scrollWidth && this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollRightButton.classList.remove('-hide');
    }

    // Hide right scroll button
    if (this.posts.scrollLeft + this.posts.offsetWidth
      >= this.posts.scrollWidth && !this.scrollLeftButton.classList.contains('-hide')) {
      this.scrollRightButton.classList.add('-hide');
    }
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-cross-reference', BrixCrossReference.init);
}
